import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-127539ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "curret" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dash" }, null, -1))
const _hoisted_3 = { class: "curret" }

import { t } from '@/plugins/i18n'
import { computed } from 'vue'
import { useSite } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: ['min', 'max'],
  emits: ['update:min', 'update:max', 'update'],
  setup(__props, { emit }) {

const props = __props



const minPrice = computed({
  get: () => props.min,
  set: (v) => emit('update:min', v)
})

const maxPrice = computed({
  get: () => props.max,
  set: (v) => emit('update:max', v)
})

const compare = (val: string, val2: string, fn: any): string =>
  val && val2 ? fn(...[val, val2].map((v) => Number(v))).toString() : val

const format = (val: string, isMax: boolean): void => {
  val = parseFloat(val?.replace(/-|e/g, ''))
    .toFixed(2)
    // .replace(/(\.00)|((?<=\.\d)0)$/, '') safiri不支持后行断言
    .replace(/\.00$/, '').replace(/(\.\d)0$/, '$1')
  val = val === 'NaN' ? '' : val
  if (isMax) {
    maxPrice.value = compare(val, minPrice.value, Math.max)
  } else {
    minPrice.value = compare(val, maxPrice.value, Math.min)
  }
  emit('update')
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rel flex-ter", { ..._ctx.$attrs, [_unref(useSite)()]: true }])
  }, [
    _createVNode(_component_el_input, {
      maxlength: "5",
      modelValue: _unref(minPrice),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(minPrice) ? (minPrice).value = $event : null)),
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (format(_unref(minPrice), false)))
    }, {
      suffix: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('元')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_2,
    _createVNode(_component_el_input, {
      maxlength: "5",
      modelValue: _unref(maxPrice),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(maxPrice) ? (maxPrice).value = $event : null)),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (format(_unref(maxPrice), true)))
    }, {
      suffix: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('元')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})